import * as React from 'react';
import { SVGProps } from 'react';

const IconFolderSectionsConnectedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 1.7A.7.7 0 0 1 .7 1h5.886a1 1 0 0 1 .707.293l1.414 1.414A1 1 0 0 0 9.414 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V1.7Z"
      fill="var(--color-bg-caution)"
    />
    <path
      d="M0 3.7A.7.7 0 0 1 .7 3H13a1 1 0 0 1 1 1v8.3a.7.7 0 0 1-.7.7H1a1 1 0 0 1-1-1V3.7Z"
      fill="var(--color-bg-warning)"
    />
    <path d="M12.428 5.714 9.572 7.5v6.786l2.857-1.746V5.714Z" fill="#CCD9E0" />
    <path
      d="m12.428 5.714 3.004 1.441a1 1 0 0 1 .568.902v5.096a.7.7 0 0 1-1.013.626L12.428 12.5V5.714ZM6 6.847a.7.7 0 0 1 1.013-.626L9.571 7.5v6.786l-3.01-1.472A1 1 0 0 1 6 11.915V6.848Z"
      fill="var(--color-bg-normal)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.626 7.931 7 6.618v6.012l2.518 1.23 2.856-1.744L15 13.392v-6.05L12.492 6.14 9.626 7.93ZM12.429 5l3.166 1.519c.247.119.405.369.405.644v7.028a.5.5 0 0 1-.724.447l-2.847-1.384L9.57 15l-3.17-1.55A.714.714 0 0 1 6 12.808V5.81a.5.5 0 0 1 .724-.447L9.57 6.786 12.43 5Zm2.733 2.42Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconFolderSectionsConnectedSizeS;
